import * as React from 'react'
import Radio, {RadioProps} from '@mui/material/Radio'
import styled from 'styled-components'
import SvgIconAtom from '../../to_content/svg_icon/svg_icon.atom'

const apAtomName = {ap_atom_name: 'radioAtom'}

const RadioAtom = styled((props: RadioProps) => (
  <Radio
    {...apAtomName}
    {...props}
    checkedIcon={<SvgIconAtom ap_type="cardCheckSelected" width="18" />}
    icon={<SvgIconAtom ap_type="cardCheckUnselected" width="18" />}
  />
))``

export default RadioAtom
